import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatErr(detail) {
  const clean = (s) => String(s).replace(/^Value error, /, "");
  if (detail == null) return "Что-то пошло не так";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? clean(e.msg) : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return clean(detail.msg);
  return String(detail);
}
